






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, url } from 'vuelidate/lib/validators';
import { ListApp } from './models/ListApp';
import ContentHighlightsListItemEdit from './ContentHighlightsListItemEdit.vue';

@Component({
	mixins: [validationMixin],
	validations: {
		value: {
			heading: { required },
			items: {
				$each: {
					url: { required, url },
					label: { required },
					description: { required },
					image: { url },
				}
			}
		}
	},
	components: {
		ContentHighlightsListItemEdit
	}
})
export default class ContentHighlightsListAppEdit extends Vue {
 @Prop() public value: ListApp;

 public markAsTouched(key: keyof ListApp) {
		const field = this.$v.value[key];
		if (field) {
			field.$touch();
	 }
	 this.$emit('input', this.$v.$invalid);
	}

	public getErrorMessage(fieldName: string & keyof ListApp, label: string): string | null {
		const field = this.$v.value[fieldName];
		if (field && field.$dirty && field.$invalid) {
			if (field.$params.required && !field.required) {
				return `${label} is required`;
			}
		}
		return null;
	}

	public addItem() {
		this.value.items.push({
			url: '',
			description: '',
			label: '',
			image: ''
		});
		this.$emit('input', this.$v.$invalid);
	}

	public removeItem(itemIndex: number) {
		if (this.value.items.length <= 1) {
			return;
		}
		this.value.items.splice(itemIndex, 1);
		this.$emit('input', this.$v.$invalid);
	}

	public getItemValidation(index: number) {
		return this.$v.value?.items?.$each?.[index];
	}
}
